import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutTableSettlementMultiCurrency extends Layout {
    sourcePayrollControlMulticurrency: DataSource;
    tableMulticurrency: Table;
}
